import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventsBrowseRoutingModule } from './events-browse-routing.module';
import { SharedModule } from '../shared/shared.module';
import { EventsBrowseComponent } from './events-browse/events-browse.component';
import { EventsMapComponent } from './events-map/events-map.component';
import { EventsListComponent } from './events-list/events-list.component';
import { EventsMapCarouselComponent } from './events-map/events-map-carousel/events-map-carousel.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EventsBrowseRoutingModule,
    EventsBrowseComponent,
    EventsMapComponent,
    EventsListComponent,
    EventsMapCarouselComponent,
  ],
  providers: [],
})
export class EventsBrowseModule { }
